import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ameren-error-splash',
  templateUrl: './error-splash.component.html',
  styleUrls: ['./error-splash.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class ErrorSplashComponent {
  @Input() errorDetail = 'Something went wrong, please try again in a few minutes.';

  constructor() {}
}
